import { topicPartRepository } from "../../../providers/repositories/topicPartRepository";
import { TopicPart } from "../entities/TopicPart";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const updateTopicPartOrderUseCase = {
    async exec(list: TopicPart[]): Promise<boolean> {
        try {
            await topicPartRepository.updateOrder(list);
            toast.success(t('action.updateSuccess'));
            return true;
        } catch (error) {
            Logger.error('updateTopicPartOrderUseCase', error);
            toast.error(t('action.updateError'));
        }
        return false;
    },
}; 